import { BaseState } from '../models';
import { IncomeListResponse, IncomeDetailResponse } from '../../api-models/income';

export type ReportDetails = BaseState<IncomeDetailResponse>;
export type ReportList = BaseState<IncomeListResponse>;

export type ReportState = {
  summary: ReportList;
  summaryDetails: ReportList;
};

export type ReportStateAll = ReportState;

export const initialReportState: ReportState = {
  summary: { loading: false, response: undefined },
  summaryDetails: { loading: false, response: undefined },
};

export const initialStateAll: ReportStateAll = initialReportState;

declare module './../models' {
  interface StateAll {
    // match to a duck folder
    customerReport: ReportStateAll;
  }
}
